import { Currency } from 'dinero.js';
import { useAppSelector } from './redux';

export function useCurrency(): Currency {
  const { collectionCreator } = useAppSelector((state) => state.collection);

  return collectionCreator.currency;
}
